export default __webpack_public_path__ + "static/media/awareness-trifold.87064868.png";